export default ['easy', 'normal', 'difficult', 'legendary'];